import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FiltroEmpleado } from 'src/app/shared/models/filtros';
import { DatosEmpleadosService } from '../../../services/mantenimiento/datos-empleados.service';
import { DesplegableData, SeleccionItems } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';
import { DropDownMultiseleccionComponent } from 'src/app/shared/components/sqp-components/sqpDesplegable/components/drop-down-multiseleccion/drop-down-multiseleccion.component';

@Component({
  selector: 'app-empleados-filtros',
  templateUrl: './empleados-filtros.component.html',
  styleUrls: ['./empleados-filtros.component.css']
})
export class EmpleadosFiltrosComponent implements OnInit {

  @Input() empresasList: DesplegableData[] = [];
  @Input() centrosList: DesplegableData[] = [];
  @Input() textoBuscar: string;
  limpiarTodo: {num: number, clear: boolean} = { num: 0, clear:false};
  @Output() limpiarTodoEmitter: EventEmitter<{num: number, clear: boolean}> = new EventEmitter<{num: number, clear: boolean}>();
  @Output() limpiarBuscador: EventEmitter<string> = new EventEmitter<string>();
  @Output() filtrosNuevosEmitter: EventEmitter<FiltroEmpleado[]> = new EventEmitter<FiltroEmpleado[]>();
  filtrosEmpleados: FiltroEmpleado[] = [];

  @ViewChild('empresaDropdown') empresaDropdown: DropDownMultiseleccionComponent;
  @ViewChild('centroDropdown') centroDropdown: DropDownMultiseleccionComponent;
  private timeoutId: any; // Add timeoutId

  constructor(private datosEmpleadosService: DatosEmpleadosService) { }

  ngOnChanges(changes: SimpleChanges){
    if(changes.textoBuscar){
      // Clear any existing timeout
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      // Set a new timeout
      this.timeoutId = setTimeout(() => {
        if(changes.textoBuscar.currentValue != ''){
          let filtro;
          filtro = {
            text: 'Buscar',
            buscar: changes.textoBuscar.currentValue
          }
          let index = this.filtrosEmpleados.findIndex(x=> x.text == filtro.text)
          if(index == -1) this.filtrosEmpleados.push(filtro);
          else this.filtrosEmpleados[index] = filtro;
        }
        if(changes.textoBuscar.currentValue == ''){
          let indexEliminar = this.filtrosEmpleados.findIndex(x=> x.text == 'Buscar')
          if(indexEliminar>-1) this.filtrosEmpleados.splice(indexEliminar,1);
        }

        this.filtrosNuevosEmitter.emit(this.filtrosEmpleados);
      }, 2000); //esperamos 2 segundos antes de empezar la búsqueda
    }
  }

  ngOnInit(): void {

  }

  anadirFiltros(seleccion: SeleccionItems){
    let valoresSeleccionados: string[] = [];
    seleccion.items.forEach(x=> valoresSeleccionados.push(x.id))
    let filtro: FiltroEmpleado;
    filtro = {
      text: seleccion.tipo,
      listaValores: valoresSeleccionados
    }
    let index = this.filtrosEmpleados.findIndex(x=> x.text == seleccion.tipo);

    //actualizamos el tipo de filtro con nuevos valores
    if(index == -1) this.filtrosEmpleados.push(filtro);
    else this.filtrosEmpleados[index] = filtro;

    //eliminamos el filtro que le hemos quitado todas las opciones seleccionadas
    let indexEliminar = this.filtrosEmpleados.findIndex(x=> x.listaValores?.length==0)
    if(indexEliminar>-1) this.filtrosEmpleados.splice(indexEliminar,1);
    this.filtrosNuevosEmitter.emit(this.filtrosEmpleados);
  }

  limpiarFiltros(){
    this.filtrosEmpleados = [];
    this.limpiarBuscador.emit('');
    if (this.empresaDropdown) this.empresaDropdown.limpiarFiltro();
    if (this.centroDropdown) this.centroDropdown.limpiarFiltro();
  }

  isFiltrosLimpios(): number {
    let contador:number = 0;
    this.filtrosEmpleados.forEach(x=>{
      if(x.text=='Buscar' && x?.buscar!=='') contador++;
      if(x.listaValores?.length>0) contador++;
    })
    return contador;
  }
}
